import dayjs from "dayjs"
import utc from "dayjs/plugin/utc"

dayjs.extend(utc)

export const formatDateToLocalTime = (date: string | undefined) => {
  if (!date) return ""

  return dayjs.utc(date).format("M/D/YYYY h:mm:ss A")
}
